import { VIDEO_TEMPLATE_ROUTE } from '@anm/constants/routes';
import usePageParams from '@anm/hooks/usePageParams';
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import routes from '../../../routes';
import { filterSelectors } from '../../../store/modules/filter';
import { templateActions, templateSelectors } from '../../../store/modules/template';
import { getAspectParam } from '../TemplateViewModal/helpers';

const { Router } = routes;

const useTemplatesPager = () => {
  const dispatch = useDispatch();
  const { embed, isSemrush } = usePageParams();
  const { isPending } = useSelector(templateSelectors.getTemplateItemsState);

  const aspects = useSelector(templateSelectors.selectTemplateItemsAspects);
  const canMergeList = useSelector(templateSelectors.selectTemplateItemsStateMerge);
  const pageName = useSelector(templateSelectors.selectTemplatePage);
  const pagesCount = useSelector(templateSelectors.selectTemplatesPagesCount);
  const searchName = useSelector(filterSelectors.selectSearchName);
  const currentPage = useSelector(templateSelectors.selectTemplatesCurrentPage);

  const route = VIDEO_TEMPLATE_ROUTE;
  const isSearchPage = pageName === 'search';
  const canShowLoader = isPending && !canMergeList;

  const aspectParam = aspects ? getAspectParam(aspects) : null;

  const commonRouteParams = {
    pageName: pageName as string,
    ...(embed && { embed }),
    ...(isSemrush && { isSemrush }),
    ...(isSearchPage && { name: searchName }),
    ...(aspectParam && { aspects: aspectParam })
  };

  const link = {
    route,
    params: commonRouteParams
  };

  const handleLoadMore = useCallback(
    (page: number) => {
      dispatch(templateActions.fetchTemplateListByPage({ page, canMerge: true }));

      Router.pushRoute(
        route,
        {
          ...commonRouteParams,
          pageNumber: `${page}`
        },
        { shallow: true }
      );
    },
    [pageName, aspectParam, searchName]
  );

  return [link, pagesCount, currentPage, canShowLoader, handleLoadMore] as const;
};

export default useTemplatesPager;
